'use client'

import { useEffect, useRef } from "react";
import Slider from "react-slick";
import TeamDataJson from '@/assets/data/connected-teams.json'
import NextImage from "../NextImage";
import PropTypes from 'prop-types'

const Team = (props) => {

    const { currentSlide, items } = props

    let sliderRef = useRef(null)

    useEffect(() => {
        sliderRef.slickGoTo(currentSlide)
    }, [currentSlide])

    return (
        <div className="py-[60px]slider-container">
            <div className={`max-w-7xl mx-auto`}>
                <Slider
                    infinite
                    slidesToShow={1}
                    arrows={false}
                    swipeToSlide={false}
                    swipe={false}
                    ref={slider => {
                        sliderRef = slider;
                    }}
                >
                    {
                        items?.map(item => {

                            const team = TeamDataJson?.[item?.key]
                            return (
                                <div key={item?.key} >
                                    <p className="md:text-lg text-xl text-center text-[#35343A] max-w-3xl mx-auto md:mb-12 mb-16 last:mb-0 z-20">
                                        {team?.desc}
                                    </p>
                                    <div className="flex flex-wrap items-stretch justify-center md:gap-2 gap-6 w-full">
                                        <div className='w-full flex items-center justify-center' >
                                            <Card member={team?.lead} lead />
                                        </div>
                                        {team?.members?.map((member, index) => (
                                            <Card key={index} member={member} index={index} />
                                        ))}
                                    </div>
                                </div>
                            )
                        })
                    }
                </Slider>
            </div>
        </div>
    );
};

const Card = ({ member, lead }) => {

    return (
        <div className="bg-[#98AABE]/80 hover:shadow-2xl group hover:border-[#EB532E] select-none duration-300 border-4 rounded-3xl border-[#E8F2F6] text-center text-white w-full max-w-[390px] xl:max-w-[360px] flex-initial p-4 flex flex-col justify-center">
            <div className={`flex items-center mb-3 justify-evenly ${lead ? 'flex-col gap-3' : ''}`}>
                <div className="flex-none w-16 h-16">
                    <NextImage
                        className="object-cover overflow-hidden w-16 h-16 rounded-full duration-300 border-2 border-[#E8F2F6] group-hover:border-[#EB532E]"
                        src={member?.picture}
                        alt={member?.name}
                    />
                </div>
                <div>
                    <div className="text-lg font-semibold">{member?.name}</div>
                    <div className="text-base">{member?.location}</div>
                    <div className="text-xl font-bold">{member?.position}</div>
                </div>
            </div>
            {!lead ? (
                <div className="flex flex-wrap w-full mb-3 text-[#75879C] justify-center items-center">
                    {member?.skills?.map((skill, i) => (
                        <div
                            key={i}
                            className={`flex items-center justify-center px-4 mb-4 py-2 duration-300 bg-white rounded-full ${i === 2 ? 'min-w-[180px] justify-center' : 'w-fit'
                                } ${i === 2 ? '' : 'mr-3 '}`} // Adjust for full width on index 2
                        >
                            <p className="text-sm font-semibold">{skill}</p>
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
};

Card.propTypes = {
    member: PropTypes.object
}

Team.propTypes = {
    currentSlide: PropTypes.number,
    items: PropTypes.array
}

export default Team